import Vue from 'vue';
import store from './../../store';
import transTransformer from './../../transformers/warehouseTransactionV2';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transactions = transTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedWarehouseTransactionsV2', { transactions, pagination });
  // store.dispatch('fetchPaginatedWarehouseTransactionsV2', transactions);
  resolve({ transactions, pagination });
};

const failed = (error, reject) => reject(error);

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`warehouses/${options.id}/transactionsV2`, options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/transactionsV2.js